<template>
    <div class="auth-wrapper auth-v1 px-2">
      <div class="auth-inner py-2">
        <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-large
        rounded="sm"
      >
        <!-- Register v1 -->
        <b-card class="mb-0">
          <b-link class="brand-logo">
            <h2 class="brand-text text-primary ml-1">
              CloudFit Pro
            </h2>
          </b-link>
  
          <b-card-title class="mb-1">
            即時通行證 🚀
          </b-card-title>
          <b-card-text class="mb-2">
          </b-card-text>
  
          <!-- form -->
          <validation-observer ref="registerForm">
            <h4 class="brand-text text-primary ml-1" v-if="valid === false">Invalid Link</h4>
            <b-form v-if="insert === false && valid === true">
              <b-form-group
                label="商戶 Client Name"
                label-for="client"
              >
                <b-form-input
                  id="client_name"
                  v-model="plan.client_name"
                  trim
                  readonly
                />
  
              </b-form-group>
  
              <b-form-group
                label="通行證名稱  Pass Name"
                label-for="Class Name"
              >
                <b-form-input
                  id="name"
                  v-model="plan.code"
                  trim
                  readonly
                />
  
              </b-form-group>

              <b-form-group
                label="通行證可使用時間 (分鐘) "
                label-for="Allow Time"
              >
                <b-form-input
                  id="class_date"
                  v-model="plan.time_limit"
                  trim
                  readonly
                />
  
              </b-form-group>
             
  
            
              <b-form-group
                label="價錢 Price"
                label-for="Price"
              >
                <b-form-input
                  id="price"
                  style="color:red;font-weight: bold;"
                  v-model="plan.price"
                  trim
                  readonly
                />
  
              </b-form-group>
              <hr />
              <b-form-group
                 label="你的姓名 Your Name"
                 label-for="member_name"
               >
                 <b-form-input
                   v-model="client.name"
                   trim
                 />
  
               </b-form-group>
               <b-form-group
                 label="你的 whatsapp *接收QR code用"
                 label-for="mobile"
               >
               <b-input-group>
                    <b-form-input placeholder="whatsapp number"  v-model="client.mobile"/>
                    <b-input-group-append>
                    <b-button type="button" variant="outline-success" @click="verify_code()">
                        接收驗證碼
                    </b-button>
                    </b-input-group-append>
                </b-input-group>
  
               </b-form-group>
               <b-form-group
                 label="驗證碼"
                 label-for="mobile"
               >
                 <b-form-input
                   id="card"
                   v-model="client.verify_code"
                   trim
                 />
  
               </b-form-group>
               <hr />
               <b-form-group
                 label="Credit Card Number"
                 label-for="card"
               >
                 <b-form-input
                   id="card"
                    v-mask="'#### #### #### ####'"
                   v-model="card.number"
                   trim
                 />
  
               </b-form-group>
  
             <b-form-group
               label="Expiry Date (YYYY-MM)"
               label-for="Expiry Date"
             >
               <b-form-input
                 id="expire"
                 v-mask="'####-##'"
                 v-model="card.expire"
                 trim
               />
  
             </b-form-group>
  
            <b-form-group
              label="CVC"
              label-for="cvc"
            >
              <b-form-input
                id="cvc"
                v-mask="'###'"
                v-model="card.cvc"
                trim
              />
  
            </b-form-group>
  
              <!-- checkbox -->
              <!--<b-form-group>
                <b-form-checkbox
                  id="register-privacy-policy"
                  v-model="status"
                  name="checkbox-1"
                >
                  I agree to
                  <b-link>privacy policy & terms</b-link>
                </b-form-checkbox>
              </b-form-group>
  
               -->
              <b-button
                variant="primary"
                block
                type="button"
                @click="submit"
              >
                Submit
              </b-button>
              <b-row class="mt-2">
              <b-col><b-img style="width:100%" :src="require('@/assets/images/svg/mastercard.svg')" /></b-col>
              <b-col><b-img style="width:100%"  :src="require('@/assets/images/svg/unionpay.svg')" /></b-col>
              <b-col><b-img style="width:100%"  :src="require('@/assets/images/svg/visa.svg')" /></b-col>
              <b-col><b-img style="width:100%"  :src="require('@/assets/images/svg/ae.png')" /></b-col>
            </b-row>
            </b-form>
          </validation-observer>
        </b-card>
      <!-- /Register v1 -->
       </b-overlay>
      </div>
    </div>
  </template>
  
  <script>
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import {
    BCard, BLink, BCardTitle, BCardText, BForm,BImg,BRow,BCol,
    BButton, BFormInput, BFormGroup, BInputGroup, BInputGroupAppend, BFormCheckbox,BOverlay
  } from 'bootstrap-vue'
  import router from '@/router'
  import VuexyLogo from '@core/layouts/components/Logo.vue'
  import { required, email } from '@validations'
  import { togglePasswordVisibility } from '@core/mixins/ui/forms'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  
  export default {
    components: {
      VuexyLogo,
      BImg,BRow,BCol,
      // BSV
      BCard,
      BLink,
      BCardTitle,
      router,
      BCardText,
      BForm,
      BButton,
      BOverlay,
      BFormInput,
      BFormGroup,
      BInputGroup,
      BInputGroupAppend,
      BFormCheckbox,
      // validations
      ValidationProvider,
      ValidationObserver,
    },
    mixins: [togglePasswordVisibility],
    watch: {
    "card.number": {
      handler(newValue, oldValue) {
        console.log(newValue.substring(0,1))
        switch (newValue.substring(0,1)) {
          case "3":
            this.credit_card_format = '#### ###### #####'
            this.cvc_format = '####'
            break;
          default:
          this.credit_card_format = '#### #### #### ####'
            this.cvc_format = '###'
        }
      }
    }
  },
    data() {
      return {
        regEmail: '',
        username: '',
        loading: false,
        valid : true,
        password: '',
        status: '',
        insert: false,
        client : {
            name: null,
            mobile: null,
            verify_code: null,
        },
        plan : {
          code: null,
          time_limit: null,
          price: null,
          period_quantity: null,
          period_unit: null, 
          uuid: null
        },
        card: {
          number : null,
          expire : null,
          cvc: null,
        },
        // validation rules
        required,
        email,
      }
    },
    computed: {
      passwordToggleIcon() {
        return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
      },
    },
    created() {
      this.get_plan_detail()
    },
    methods: {
        get_plan_detail() {
        this.$http.get(process.env.VUE_APP_API_BASE+`/plan/`+ router.currentRoute.params.plan_uuid + `/`)
          .then(res => {
            if (res.data.result === false ) {
              this.valid = false
            } else {
              this.plan = res.data.plan
            }
          })
      },
      submit() {
      this.loading = true
      this.$http.post(process.env.VUE_APP_API_BASE+`/payment_gateway/stripe/${this.plan.centers}/`, {
        card : this.card,
        client : this.client,
        plan : this.plan,
        "method" : "paylink",
        "type" : "daypass"
      })
        .then(res => {
          if (res.data.result === true) {
            this.valid = false
            this.loading = false
            this.$swal({
              title: '以下是QR code通行證',
              html: '我們亦會用WhatsApp傳送二維碼給你.<br><br><img src="https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=' + res.data.token + '">',
              icon: 'success',
              showConfirmButton : false,
              buttonsStyling: false,
              backdrop: false,
            })
          } else {
            this.loading = false
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    verify_code() {
      this.loading = true
      this.$http.post(process.env.VUE_APP_API_BASE+`/whatsapp/verify_code/`, {
        mobile : this.client.mobile
      })
        .then(res => {
          if (res.data.result === true) {
            this.loading = false
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'XCheck',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.loading = false
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    }
    }
  }
  
  </script>
  
  <style lang="scss">
  @import '@core/scss/vue/pages/page-auth.scss';
  </style>
  